export default "__VITE_ASSET__COyCLfy8__"